// Stamped by scripts/write-release.mjs when GITHUB_SHA or .preview-client-id is
// present. These committed values are the local and unit-test defaults.
// releaseVersion matches the Datadog sourcemap upload (`github.sha`).
// previewClientId is the ephemeral Sirius client for a PR preview.
export const releaseVersion = 'a1f724c2ae9f03a8803cb83ebf40b86eb95cd962';
export const previewClientId = 'future-room-preview-future-room-7-sprgge2x';
